import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const FullScreenLoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${Variables.colors.complementary};
  opacity: 0.7;
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .spinner {
    width: 72px;
    height: 72px;

    position: relative;
    margin: 100px auto;
  }
  .double-bounce1,
  .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${Variables.colors.primary_400};
    opacity: 0.3;
    position: absolute;
    top: 0;
    left: 0;

    -webkit-animation: sk-bounce 2s infinite ease-in-out;
    animation: sk-bounce 2s infinite ease-in-out;
  }
`;
